module.exports = __webpack_public_path__ + "static/media/yiyuan13.30630a43.png";